import { Accordion, Box, Group, Select, Stack, Text, UnstyledButton } from '@mantine/core';
import { ArrowRight } from 'react-feather';
import type { JobTitleGroup } from '../../../../hooks/useJobTitles';

interface TeamAssignmentsSectionProps {
  teamAssignments: Record<string, string | null>;
  handleAssignmentChange: (jobTitleId: string, userId: string | null) => void;
  userOptions: { value: string; label: string }[];
  jobTitleGroups: JobTitleGroup[];
  classes: Record<string, string>;
  onAutoPopulate?: () => void;
}

export function TeamAssignmentsSection({
  teamAssignments,
  handleAssignmentChange,
  userOptions,
  jobTitleGroups,
  classes,
  onAutoPopulate,
}: TeamAssignmentsSectionProps) {
  return (
    <Accordion.Item value="team-assignments">
      <Accordion.Control>
        <Text fw={600}>Team Assignments</Text>
      </Accordion.Control>
      <Accordion.Panel>
        {onAutoPopulate && (
          <Group justify="flex-end" mb="sm">
            <UnstyledButton
              onClick={onAutoPopulate}
              style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
            >
              <Text size="sm" c="var(--medley-green-primary)" style={{ cursor: 'pointer' }}>
                Auto-populate
              </Text>
              <ArrowRight size={14} color="var(--medley-green-primary)" />
            </UnstyledButton>
          </Group>
        )}
        <Stack gap="lg">
          {jobTitleGroups.map((group) => (
            <Box key={group.category}>
              <Text
                className={classes.categoryHeader}
                mb="sm"
                c={group.disabled ? 'dimmed' : undefined}
              >
                {group.category}
              </Text>
              {group.disabled ? (
                <Text size="xs" c="dimmed" fs="italic">
                  No roles assigned to this function.
                </Text>
              ) : (
                <Stack gap="sm">
                  {group.titles.map((title) => (
                    <Group key={title.id} grow>
                      <Text size="sm" c="dimmed" style={{ flex: '0 0 200px' }}>
                        {title.name}
                      </Text>
                      <Select
                        placeholder="Unassigned"
                        data={userOptions}
                        value={teamAssignments[title.id]}
                        onChange={(value) => handleAssignmentChange(title.id, value)}
                        clearable
                        searchable
                      />
                    </Group>
                  ))}
                </Stack>
              )}
            </Box>
          ))}
        </Stack>
      </Accordion.Panel>
    </Accordion.Item>
  );
}
